import React from 'react';
import { Briefcase, DollarSign, TrendingUp, Scale, FileText, Globe } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const NewsCategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', label: 'All Categories', icon: Globe, count: null },
    { id: 'hr', label: 'HR Updates', icon: Briefcase, color: 'blue' },
    { id: 'payroll', label: 'Payroll', icon: DollarSign, color: 'green' },
    { id: 'tax', label: 'Tax & SWT', icon: TrendingUp, color: 'purple' },
    { id: 'minimum_wage', label: 'Minimum Wage', icon: DollarSign, color: 'orange' },
    { id: 'employment_act', label: 'Employment Act', icon: Scale, color: 'red' },
    { id: 'gazette', label: 'Gazette', icon: FileText, color: 'indigo' },
    { id: 'general', label: 'General', icon: Globe, color: 'gray' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Categories</h3>
      <div className="space-y-2">
        {categories?.map((category) => {
          const Icon = category?.icon;
          const isSelected = selectedCategory === category?.id;
          
          return (
            <button
              key={category?.id}
              onClick={() => onCategoryChange(category?.id)}
              className={`
                w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all
                ${isSelected
                  ? 'bg-blue-50 text-blue-700 border-2 border-blue-200' :'bg-gray-50 text-gray-700 hover:bg-gray-100 border-2 border-transparent'
                }
              `}
            >
              <Icon className={`w-5 h-5 flex-shrink-0 ${isSelected ? 'text-blue-600' : 'text-gray-500'}`} />
              <span className="flex-1 text-left text-sm font-medium">{category?.label}</span>
              {category?.count && (
                <span className={`text-xs px-2 py-1 rounded-full ${
                  isSelected ? 'bg-blue-100 text-blue-700' : 'bg-gray-200 text-gray-600'
                }`}>
                  {category?.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {/* Quick Actions */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-sm font-semibold text-gray-900 mb-3">Quick Actions</h4>
        <div className="space-y-2">
          <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors">
            📌 View Pinned Updates
          </button>
          <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors">
            ⭐ Featured Articles
          </button>
          <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors">
            🔔 Critical Alerts
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsCategoryFilter;